import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useGlobal } from '../context/GlobalContext';
import { applySeoMetadata } from '../lib/seo';
import { isEnglishLocale } from '../lib/locale';
import flechaIzq from '../assets/icons/icon_flecha_izq.svg';
import styles from './NotFound.module.css';

const NotFound = () => {
  const { companyInfo, locale } = useGlobal();
  const isEn = isEnglishLocale(locale);
  const botonLabel = (companyInfo?.boton404 || '').trim();

  useEffect(() => {
    applySeoMetadata({
      companyInfo,
      locale,
      noIndex: true,
      requestedSlug: '404',
      seo: {
        metaTitle: isEn ? '404 | Page not found' : '404 | Página no encontrada',
        metaDescription: isEn
          ? 'The page you are looking for does not exist.'
          : 'La página que buscas no existe.',
      },
    });
  }, [companyInfo, locale, isEn]);

  return (
    <section className={styles.notFound}>
      <div className={styles.notFound__content}>
        <span className={styles.notFound__face} aria-hidden="true">:(</span>
        <h1 className={styles.notFound__code}>404</h1>
        <Link
          to="/"
          className={`${styles.notFound__cta} ${!botonLabel ? styles['notFound__cta--icon'] : ''}`}
          aria-label={botonLabel || (isEn ? 'Back to home' : 'Volver al inicio')}
        >
          {botonLabel ? (
            botonLabel
          ) : (
            <img src={flechaIzq} alt="" className={styles.notFound__ctaIcon} />
          )}
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
